require("./bootstrap");

require("jquery-validation");

$.validator.addMethod(
  "regex",
  function (value, element, regexp) {
    let re = new RegExp(regexp);
    return this.optional(element) || re.test(value);
  },
  "Please check your input."
);
$.validator.addMethod(
  "containsUppercaseLetter",
  function (value, element) {
    let re = new RegExp(/(?=.*[A-Z])/);
    return this.optional(element) || re.test(value);
  },
  "You must have at least one uppercase letter."
);
$.validator.addMethod(
  "containsLowercaseLetter",
  function (value, element) {
    let re = new RegExp(/(?=.*[a-z])/);
    return this.optional(element) || re.test(value);
  },
  "You must have at least one lowercase letter."
);
$.validator.addMethod(
  "containsNumber",
  function (value, element) {
    let re = new RegExp(/(?=.*\d)/);
    return this.optional(element) || re.test(value);
  },
  "You must have at least one number."
);
$.validator.addMethod(
  "containsSymbol",
  function (value, element) {
    let re = new RegExp(/(?=.*\W)/);
    return this.optional(element) || re.test(value);
  },
  "You must have at least one symbol."
);
$.validator.addMethod(
  "notContainsUsername",
  function (value, element) {
    let username = $(this.currentForm).find("#name").val();

    if (username.length === 0) {
      return true;
    }

    let re = new RegExp(`(?=.*${username})`, "i");
    return this.optional(element) || !re.test(value);
  },
  "Your password must not contain your username."
);
$.validator.addMethod(
  "notContainsEmail",
  function (value, element) {
    let email = $(this.currentForm).find("#email").val();
    let re = new RegExp(`(?=.*${email})`, "i");
    return this.optional(element) || !re.test(value);
  },
  "Your password must not contain your email address."
);

require("./g-autocomplete");
require("./interactive-map");

require("./main");
